// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g9KXw","clinicsSelect":"styles_clinicsSelect__1HzH-"};